module.exports = __webpack_public_path__ + "static/media/desenhos_diversos2.da563a7b.jpg";